/**
 * Gas cylinder list Price column.
 * sales_price is per cylinder; sales_value is qty × unit.
 */

export function gasCylinderSaleLineAmount(row) {
  const salesValue = Number(row?.sales_value);
  if (Number.isFinite(salesValue) && salesValue > 0) {
    return salesValue;
  }

  const qty = Number(row?.qty);
  const unit = Number(row?.sales_price);
  const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1;
  const safeUnit = Number.isFinite(unit) ? unit : 0;

  return safeQty * safeUnit;
}

export function formatGasCylinderSaleLineAmount(row) {
  return Number(gasCylinderSaleLineAmount(row) || 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
